/* Personalized edition landing (v2): the hero's story/gallery toggle and the "Take a look inside" viewer.
   GG Product Gallery draws into .pmslider-manual-install (its app embed is theme-wide). It stays laid out but
   hidden (visibility + opacity, and inert) in story mode so it measures its real size; opening it shows it and moves
   it to photo 2.
   GG's API (checked 2026-10-01 on /products/i-did-not-come-from-apes): there is no public slider object. Its globals
   (pmsliderConfig, pmsliderInstallConfig, pmsliderTT, ...) are config and helpers, not a slideTo(). Its thumbnails
   are span.pmslider-dots_dot (the current one has .pmslider-dots_dot--current), and click() on the second one
   moves the track to photo 2 (translateX(-565px), data-pmslider-slide-active on slide 2). GG shows no counter of its
   own, so the row's .pl-count is ours. Its zoom lightbox (.ppzoom, position: fixed) is appended to <body>, outside
   the landing. The generic [class*=thumb] selector is a last resort only: on GG it matches the arrows and dots
   wrappers before the thumbnails. */
(function () {
  "use strict";
  const $ = (s, r = document) => r.querySelector(s), $$ = (s, r = document) => [...r.querySelectorAll(s)];

  // GG's thumbnails; the fallbacks are for a GG markup change (and the review fixture's fake GG).
  function ggItems(root) {
    if (!root) return [];
    for (const sel of [".pmslider-dots_dot", ".thumb", "[class*=thumb]"]) {
      const items = $$(sel, root);
      if (items.length) return items;
    }
    return [];
  }
  function ggGoTo(root, i) {
    const t = ggItems(root)[i];
    if (t) t.click();
  }
  function ggCurrent(root) {
    return ggItems(root).findIndex(t => t.classList.contains("pmslider-dots_dot--current") ||
      t.getAttribute("aria-current") === "true" || t.dataset.active === "1");
  }

  function initMedia(media) {
    const row = media.parentElement.querySelector(".pl-media-row"), gg = $(".pmslider-manual-install", media);
    const story = $(".pl-story", media), gallery = $(".pl-gallery", media), count = row && $(".pl-count", row);
    if (!row) return;
    const paintCount = () => {
      if (!count || media.dataset.mode !== "gallery") return;
      const n = ggItems(gg).length, k = ggCurrent(gg);
      count.textContent = n > 1 && k >= 0 ? (k + 1) + " / " + n : "";
    };
    const setMode = m => {
      media.dataset.mode = m;
      row.dataset.mode = m;
      if (story) story.inert = m === "gallery";
      if (gallery) gallery.inert = m !== "gallery";
      if (m === "gallery") { fit(); ggGoTo(gg, 1); window.dispatchEvent(new Event("resize")); }
      paintCount();
    };
    // GG has drawn once it has more than one photo (its real thumbnails are .pmslider-dots_dot); a lone child, such
    // as a loader, is not a gallery yet.
    const ready = () => ggItems(gg).length > 1;
    // GG's photo is square with a strip of thumbnails under it; the CSS fits photo + strip to the box using
    // --pl-gg-strip (116px desktop, 91px phone as fallbacks). Read the strip's real height whenever it can change.
    const fit = () => {
      if (!gallery || !gg) return;
      const dots = $(".pmslider-dots", gg), slides = $(".pmslider-own--slides-wrapper", gg);
      let h = 0;
      if (slides && gg.offsetHeight) h = gg.getBoundingClientRect().height - slides.getBoundingClientRect().height;
      else if (dots) { const cs = getComputedStyle(dots); h = dots.offsetHeight + parseFloat(cs.marginTop) + parseFloat(cs.marginBottom); }
      if (h > 0 && Math.abs(h - (parseFloat(gallery.style.getPropertyValue("--pl-gg-strip")) || 0)) > 1) {
        gallery.style.setProperty("--pl-gg-strip", Math.ceil(h) + "px");
      }
    };
    row.hidden = !ready();
    if (!row.hidden) fit();
    if (gg) {
      // Show the row once GG has drawn, and keep the count in step with GG's own arrows, swipe and thumbnails.
      new MutationObserver(() => {
        if (row.hidden && ready()) { row.hidden = false; fit(); }
        paintCount();
      }).observe(gg, { childList: true, subtree: true, attributes: true, attributeFilter: ["class", "data-active", "aria-current"] });
    }
    row.addEventListener("click", e => {
      const open = e.target.closest("[data-pl-open]"), close = e.target.closest("[data-pl-close]");
      if (!open && !close) return;
      const hadFocus = document.activeElement === (open || close);
      setMode(open ? "gallery" : "story");
      // The pressed button disappears; keep keyboard focus in the row.
      if (hadFocus) { const other = $(open ? "[data-pl-close]" : "[data-pl-open]", row); if (other) other.focus({ preventScroll: true }); }
    });
    let rz = 0;
    window.addEventListener("resize", () => { cancelAnimationFrame(rz); rz = requestAnimationFrame(fit); });
    setMode(media.dataset.mode === "gallery" ? "gallery" : "story");
    window.PediLanding = { setMode, fit, goToPhoto: i => ggGoTo(gg, i) };
  }

  function initViewer(v) {
    const vp = $(".pl-vp", v), track = $(".pl-track", v), slides = $$(".pl-slide", v), n = slides.length;
    if (!vp || !track || !n) return;
    let i = Math.max(0, Math.min(n - 1, +(v.dataset.start || 0) || 0)), sw = null;
    const paint = (dx = 0, anim = true) => {
      // Past the first or last page, the book follows the finger at a third of the distance.
      if ((i === 0 && dx > 0) || (i === n - 1 && dx < 0)) dx /= 3;
      track.style.transition = anim ? "transform .35s ease" : "none";
      track.style.transform = `translateX(calc(${-i * 100}% + ${dx}px))`;
      v.dataset.i = i;
      const s = slides[i];
      const cap = $(".pl-cap", v); if (cap) cap.textContent = s.dataset.label || "";
      const pg = $(".pl-pages", v); if (pg) pg.textContent = s.dataset.pages || "";
      slides.forEach((sl, k) => sl.setAttribute("aria-hidden", k === i ? "false" : "true"));
      $$(".pl-thumbs button", v).forEach((b, k) => b.setAttribute("aria-current", k === i ? "true" : "false"));
      $$(".pl-dots i", v).forEach((d, k) => d.classList.toggle("on", k === i));
    };
    const go = k => { i = Math.max(0, Math.min(n - 1, k)); paint(); };
    // The arrows wrap around, as in the mockup; a swipe stops at the first and last page.
    const step = d => go((i + d + n) % n);
    vp.addEventListener("pointerdown", e => {
      if (e.button !== 0) return;
      sw = { x: e.clientX, y: e.clientY, id: e.pointerId, lock: null };
    });
    vp.addEventListener("pointermove", e => {
      if (!sw || e.pointerId !== sw.id) return;
      const dx = e.clientX - sw.x, dy = e.clientY - sw.y;
      if (sw.lock === null && Math.abs(dx) + Math.abs(dy) > 8) {
        sw.lock = Math.abs(dx) > Math.abs(dy) ? "x" : "y";
        if (sw.lock === "x") try { vp.setPointerCapture(sw.id); } catch (_) {}
      }
      if (sw.lock === "x") paint(dx, false);
    });
    const end = e => {
      if (!sw || e.pointerId !== sw.id) return;
      const dx = e.clientX - sw.x, horiz = sw.lock === "x"; sw = null;
      if (horiz && dx < -40) go(i + 1); else if (horiz && dx > 40) go(i - 1); else paint();
    };
    vp.addEventListener("pointerup", end);
    // A cancelled gesture (the browser took over, a call came in) never turns the page: the book springs back.
    vp.addEventListener("pointercancel", e => { if (!sw || e.pointerId !== sw.id) return; sw = null; paint(); });
    vp.addEventListener("keydown", e => {
      if (e.key === "ArrowRight") { e.preventDefault(); go(i + 1); }
      if (e.key === "ArrowLeft") { e.preventDefault(); go(i - 1); }
    });
    v.addEventListener("click", e => {
      if (e.target.closest("[data-pl-prev]")) step(-1);
      if (e.target.closest("[data-pl-next]")) step(1);
      const t = e.target.closest(".pl-thumbs button[data-i]"); if (t) go(+t.dataset.i);
    });
    paint(0, false);
  }

  /* ---------------------------------------------------------------- motion (Oct 2026: a little polish)
     Opt-in through html.pl-motion (the section's inline script sets it before the hero is parsed, only when motion is
     allowed; the CSS hides nothing without it). transform (individual properties) and opacity only; the hero's text,
     price and Personalize button never move or wait. */
  const RM = window.matchMedia ? matchMedia("(prefers-reduced-motion: reduce)") : { matches: false };
  const motionOK = () => !RM.matches && !!Element.prototype.animate;

  /* The hero, in order (1.16 s in all): the tilted photo card settles in (0-520 ms), the arrow draws on from the photo
     to the cover (380-880 ms), the "We draw him in" bubble pops in (800-1160 ms). It waits up to 700 ms for the card's
     photo so the card never lands empty. */
  function heroIn(hero) {
    const photo = $(".pl-photo", hero), arrow = $(".pl-arrow", hero), bubble = $(".pl-bubble", hero);
    const played = () => hero.classList.add("pl-played");
    if (!motionOK() || !document.documentElement.classList.contains("pl-motion")) return played();
    let started = false;
    const go = () => {
      if (started) return; started = true;
      if (photo) photo.animate([{ opacity: 0, translate: "-14px 26px", rotate: "-6deg", scale: "0.94" }, { opacity: 1, translate: "0 0", rotate: "0deg", scale: "1" }],
        { duration: 520, easing: "cubic-bezier(.24,1.18,.42,1)", fill: "backwards" });
      if (arrow && arrow.getClientRects().length) {
        arrow.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 60, delay: 380, fill: "backwards" });
        $$("path", arrow).forEach(pa => {
          // the strokes are non-scaling, so their dashes are in screen pixels: the path's length times its on-screen scale
          let L = 0;
          try { const m = pa.getScreenCTM(); L = pa.getTotalLength() * (m ? Math.hypot(m.a, m.b) : 1); } catch (e) {}
          if (!L) return;
          L = Math.ceil(L * 1.04) + 2;
          pa.style.strokeDasharray = L + " " + L;
          const hd = pa.classList.contains("hd");      // the curve draws first (380-760 ms), then its head (760-880 ms)
          const a = pa.animate([{ strokeDashoffset: L }, { strokeDashoffset: 0 }],
            { duration: hd ? 120 : 380, delay: hd ? 760 : 380, easing: hd ? "ease-out" : "cubic-bezier(.45,0,.25,1)", fill: "backwards" });
          a.onfinish = a.oncancel = () => { pa.style.strokeDasharray = ""; };
        });
      }
      if (bubble) bubble.animate([{ opacity: 0, scale: "0.82", translate: "0 10px" }, { opacity: 1, scale: "1", translate: "0 0" }],
        { duration: 360, delay: 800, easing: "cubic-bezier(.34,1.5,.64,1)", fill: "backwards" });
      played();
    };
    const img = photo && $("img", photo);
    if (!img || img.complete) go();
    else { img.addEventListener("load", go, { once: true }); img.addEventListener("error", go, { once: true }); setTimeout(go, 700); }
  }

  /* The sections under the hero (and each How it works step, each review, each question) fade in with a 12 px rise as
     they scroll into view, a few at a time 70 ms apart. Anything already in view at load is left alone (shown at once). */
  const REVEAL = [".pl-how-card > .pl-head", ".pl-step", ".pl-how-card > .pl-center", ".pl-ex > .pl-head", ".pl-exband", ".pl-ex > .pl-center",
    ".pl-inside-card", ".pl-craft-card", ".pl-gift-card", ".pl-about-card", ".pl-revhead", ".pl-rv", ".pl-faq > h2", ".pl-qa", ".pl-final-card"];
  function reveals(root) {
    if (!motionOK() || !("IntersectionObserver" in window)) return;
    document.documentElement.classList.add("pl-motion");
    const els = $$(REVEAL.join(","), root), vh = innerHeight;
    const show = (el, i) => {
      el.style.transitionDelay = Math.min(i, 4) * 70 + "ms";
      el.classList.add("pl-in");
      let t;
      const clean = e => { if (e && e.target !== el) return; clearTimeout(t); el.removeEventListener("transitionend", clean); el.classList.remove("pl-rvl", "pl-in"); el.style.transitionDelay = ""; };
      el.addEventListener("transitionend", clean); t = setTimeout(clean, 1400);
    };
    const pending = new Set();
    const io = new IntersectionObserver(entries => {
      entries.filter(e => e.isIntersecting && pending.has(e.target)).forEach((e, i) => { pending.delete(e.target); io.unobserve(e.target); show(e.target, i); });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
    // a backstop for a fast fling or a jump (an anchor link): whatever has reached the viewport or gone above it shows
    let tm = 0;
    const sweep = () => {
      let i = 0;
      pending.forEach(el => { if (el.getBoundingClientRect().top < innerHeight * 0.95) { pending.delete(el); io.unobserve(el); show(el, i++); } });
      if (!pending.size) removeEventListener("scroll", onScroll);
    };
    const onScroll = () => { clearTimeout(tm); tm = setTimeout(sweep, 120); };
    els.forEach(el => {
      const r = el.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0) return;          // in view now: never hidden
      el.classList.add("pl-rvl"); pending.add(el); io.observe(el);
    });
    if (pending.size) addEventListener("scroll", onScroll, { passive: true });
  }

  function init() {
    $$(".pl-media").forEach(initMedia); $$(".pl-viewer").forEach(initViewer);
    $$(".pl-landing").forEach(root => { const h = $(".pl-hero", root); if (h) heroIn(h); reveals(root); });
  }
  document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", init) : init();
})();
